import { Button, Divider, Flex, Group, Image, Stack } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { deleteIcon } from '@assets';
import { TextInput } from '@components';
import { classes } from '@styles';
import { TransitViewGeneralInfoFormValues } from './validateTransitViewGeneralInfoForm';

interface TransitTransportEquipmentProps {
  form: UseFormReturnType<TransitViewGeneralInfoFormValues>;
  disabled: boolean;
}

export const TransitTransportEquipment: React.FC<TransitTransportEquipmentProps> = ({ form, disabled }) => {
  const addRow = () => {
    const transportEq = form.values.Consignment.TransportEquipment || [];
    form.setFieldValue('Consignment.TransportEquipment', [
      ...transportEq,
      {
        containerIdentificationNumber: '',
        Seal: [],
      },
    ]);
  };

  const removeRow = (rowIdx: number) => {
    const transportEq = form.values.Consignment.TransportEquipment || [];
    transportEq.splice(rowIdx, 1);
    form.setFieldValue('Consignment.TransportEquipment', [...transportEq]);
  };

  const addSeal = (rowIdx: number) => {
    const seal = form.values.Consignment.TransportEquipment[rowIdx].Seal || [];
    form.setFieldValue(`Consignment.TransportEquipment.${rowIdx}.Seal`, [...seal, { identifier: '' }]);
  };

  const removeSeal = (rowIdx: number, sealIdx: number) => {
    const seal = form.values.Consignment.TransportEquipment[rowIdx].Seal || [];
    seal.splice(sealIdx, 1);
    form.setFieldValue(`Consignment.TransportEquipment.${rowIdx}.Seal`, [...seal]);
  };

  const renderFormRow = (rowIdx: number, transportEq: any) => {
    const containerPath = (equipmentIdx: number) => `Consignment.TransportEquipment.${equipmentIdx}.containerIdentificationNumber`;
    const sealPath = (equipmentIdx: number, sealIdx: number) => `Consignment.TransportEquipment.${equipmentIdx}.Seal.${sealIdx}.identifier`;

    return (
      <Stack key={`${(form.values.Consignment?.TransportEquipment || []).length}-${rowIdx}`} mb={16} gap="xs">
        <Flex mb={10}>
          <TextInput {...form.getInputProps(containerPath(rowIdx))} label={`Container ${rowIdx + 1}`} disabled={disabled} />
          {!disabled && (
            <Button
              variant="transparent"
              ml={16}
              mt={5}
              onClick={(event) => {
                event.preventDefault();
                removeRow(rowIdx);
              }}
              className={classes.cursorPointer}
            >
              <img src={deleteIcon} alt="Remove Row" />
            </Button>
          )}
        </Flex>

        {(transportEq.Seal || []).map((seal: any, sealIdx: number) => (
          <Flex mb={10} ml={16} key={`${transportEq.Seal.length}-${sealIdx}`} align="center">
            <TextInput {...form.getInputProps(sealPath(rowIdx, sealIdx))} label={`Seal ${sealIdx + 1}`} disabled={disabled} data-pw={`seal-input-${sealIdx}`} />
            {!disabled && (
              <Button
                variant="transparent"
                onClick={(event) => {
                  event.preventDefault();
                  removeSeal(rowIdx, sealIdx);
                }}
              >
                <Image src={deleteIcon} alt="Remove Seal" className={classes.cursorPointer} />
              </Button>
            )}
          </Flex>
        ))}

        {!disabled && (
          <Flex align={'center'}>
            <Group>
              <Button
                onClick={(event) => {
                  event.preventDefault();
                  addSeal(rowIdx);
                }}
                variant="outline"
                size="lg"
                data-pw={`add-seal-btn-${rowIdx}`}
              >
                Add Seal
              </Button>
            </Group>
          </Flex>
        )}

        {rowIdx < form.values.Consignment?.TransportEquipment?.length - 1 && <Divider mt="lg" />}
      </Stack>
    );
  };

  return (
    <Stack>
      {(form.values.Consignment?.TransportEquipment || []).map((transportEq, rowIdx) => renderFormRow(rowIdx, transportEq))}
      {!disabled && (
        <Flex align={'center'}>
          <Group>
            <Button
              onClick={(event) => {
                event.preventDefault();
                addRow();
              }}
              variant="outline"
              size="lg"
              data-pw="add-container-btn"
            >
              Add Container and/or Seal
            </Button>
          </Group>
        </Flex>
      )}
    </Stack>
  );
};
